const PATH = 'fe.components.measure.observation_notes';

const messages = {
  title: {
    key: `${PATH}.title`,
    defaultValue: 'Observation Notes'
  },
  cycles: {
    key: `${PATH}.cycles`,
    defaultValue: '{{count}} cycles'
  },
  cycleNumber: {
    key: `${PATH}.cycle_number`,
    defaultValue: 'Cycle {{number}}'
  }
};

export default messages;
